import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
    button: {
        color: 'grey',
        width: '150px',
        height: '30px',
        border: '1px solid #E5E5E5',
        borderRadius: '3px',
        textAlign: 'left',
        fontSize: '12px',
        textTransform: 'capitalize',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        display: 'inline-block',
    },
    buttonIcon: {
        position: 'absolute',
        bottom: '2.5px',
        right: '5px',
    },
}));
